import { ModelEffectConfig } from '@/types/effects';

export const ModelConfigs: ModelEffectConfig[] = [
  {
    modelIdKeyword: 'hat',

    allowedEffects: ['none', 'screen_print', 'gold_foil', 'fabric_embossed', 'leather_debossed', 'embroidery'],
    defaultEffect: 'none'
  },
  {
    modelIdKeyword: 'cap',
    allowedEffects: ['none', 'screen_print', 'embroidery'],
    defaultEffect: 'none'
  },
  {
    modelIdKeyword: 'polo',
    allowedEffects: ['none', 'embroidery', 'fabric_embossed'],
    defaultEffect: 'none'
  },
  {
    modelIdKeyword: 'towel',
    allowedEffects: ['none', 'sublimation', 'embroidery'],
    defaultEffect: 'none'
  },
  {
    modelIdKeyword: 'jersey',
    allowedEffects: ['none', 'screen_print', 'fabric_embossed'],
    defaultEffect: 'none'
  },
  {
    modelIdKeyword: 'tumbler',
    allowedEffects: ['none', 'screen_print'],
    defaultEffect: 'none'
  },
  {
    modelIdKeyword: 'glass',
    allowedEffects: ['none', 'glass_etching'],
    defaultEffect: 'none'
  },
  {
    modelIdKeyword: 'award',
    allowedEffects: ['none', 'glass_etching'],
    defaultEffect: 'none'
  },
  {
    modelIdKeyword: 'diary',
    allowedEffects: ['none', 'leather_debossed', 'gold_foil'],
    defaultEffect: 'none'
  },
  {
    modelIdKeyword: 'notebook',
    allowedEffects: ['none', 'screen_print', 'gold_foil', 'leather_debossed'],
    defaultEffect: 'none'
  },
  {
    modelIdKeyword: 'pen',
    allowedEffects: ['none', 'gold_foil', 'pad_print', 'laser_engraving'],
    defaultEffect: 'none'
  },
  {
    modelIdKeyword: 'jar',
    allowedEffects: ['none', 'pad_print', 'screen_print', 'gold_foil'],
    defaultEffect: 'none'
  },
  {
    modelIdKeyword: 'lanyard',
    allowedEffects: ['none', 'sublimation', 'screen_print'],
    defaultEffect: 'none'
  },
  // Generics (fitting "All models" rule for Screen Print)
  {
    modelIdKeyword: 'tshirt',
    allowedEffects: ['none', 'screen_print'], // Basic fallback
    defaultEffect: 'none'
  },
  {
    modelIdKeyword: 't-shirt',
    allowedEffects: ['none', 'screen_print'],
    defaultEffect: 'none'
  },
  {
    modelIdKeyword: 'hoodie',
    allowedEffects: ['none', 'screen_print'],
    defaultEffect: 'none'
  },
  {
    modelIdKeyword: 'jacket',
    allowedEffects: ['none', 'screen_print'],
    defaultEffect: 'none'
  },
  {
    modelIdKeyword: 'bottle',
    allowedEffects: ['none', 'screen_print'],
    defaultEffect: 'none'
  },
  {
    modelIdKeyword: 'mug',
    allowedEffects: ['none', 'screen_print'],
    defaultEffect: 'none'
  }
];

// Fallback for unknown models
export const DefaultModelConfig: ModelEffectConfig = {
  modelIdKeyword: 'default',
  allowedEffects: ['none', 'screen_print'],
  defaultEffect: 'none'
};

export function getModelConfig(glbUrl: string | undefined): ModelEffectConfig {
    if (!glbUrl) return DefaultModelConfig;
    const lowerUrl = glbUrl.toLowerCase();
    
    // Find the first config where the keyword is in the URL
    const found = ModelConfigs.find(config => lowerUrl.includes(config.modelIdKeyword));
    
    return found || DefaultModelConfig;
}
